import { CONTACT_URL } from "../constants"; // Ensure you have this constant defined
import { apiSlice } from "./apiSlice";

export const contactApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    submitContact: builder.mutation({
      query: (data) => ({
        url: `${CONTACT_URL}/contact`, // Adjust the URL as needed
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useSubmitContactMutation } = contactApiSlice;